import crypto from "crypto";

export const encryptData = ({
  salt = "",
  data,
}: {
  salt?: string;
  data: any;
}) => {
  const textToChars = (text: string) =>
    text.split("").map((c: string) => c.charCodeAt(0));

  const byteHex = (n: string) => ("0" + Number(n).toString(16)).substr(-2);

  const applySaltToChar = (code: any) =>
    textToChars(salt).reduce((a: number, b: number) => a ^ b, code);
  if (!!data) {
    return data?.split("").map(textToChars).map(applySaltToChar).join(","); // Join using a delimiter (e.g., comma)
  } else return null;
};

export const decryptData = ({
  salt = "",
  encoded,
}: {
  salt?: string;
  encoded: any;
}) => {
  try {
    const textToChars = (text: string) =>
      text.split("").map((c: string) => c.charCodeAt(0));
    const applySaltToChar = (code: any) =>
      textToChars(salt).reduce((a: number, b: number) => a ^ b, code);
    return encoded
      .split(",") // Split using the delimiter
      .map((charCode: any) => parseInt(charCode, 10)) // Parse as decimal
      .map(applySaltToChar)
      .map((charCode: any) => String.fromCharCode(charCode))
      .join("");
  } catch (e) {
    return null;
  }
};

export const encryptReqBody = (text: any): Promise<string> => {
  return aesEncrypt(
    JSON.stringify(text),
    process.env.NEXT_PUBLIC_REQUEST_BODY_ENCRYPTION as string
  );
};

export const encryptReqHeader = (text: any): Promise<string> => {
  return aesEncrypt(
    JSON.stringify(text),
    process.env.NEXT_PUBLIC_REQUEST_HEADER_ENCRYPTION as string
  );
};

export const decryptResBody = async (text: any) => {
  if (!text) {
    return null;
  }
  return JSON.parse(
    aesDecrypt(
      text,
      process.env.NEXT_PUBLIC_RESPONSE_BODY_ENCRYPTION as string
    ) as any
  );
};
export const decryptReqBody = async (text: any) => {
  return JSON.parse(
    aesDecrypt(
      text,
      process.env.NEXT_PUBLIC_REQUEST_BODY_ENCRYPTION as string
    ) as any
  );
};

export async function aesEncrypt(
  data: string,
  secretHex: string
): Promise<string> {
  // Use Node.js crypto (works both server-side and client-side with crypto-browserify)
  const keyBuffer = Buffer.from(secretHex, "hex");
  const iv = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv("aes-256-cbc", keyBuffer, iv);

  let encrypted = cipher.update(data, "utf-8");
  encrypted = Buffer.concat([encrypted, cipher.final()]);

  // Combine IV and encrypted data, then encode as Base64
  const combined = Buffer.concat([iv, encrypted]);
  return combined.toString("base64");
}

export const aesDecrypt = (base64Cipher: string, hexKey: string) => {
  if (!base64Cipher || !hexKey) {
    throw new Error("Both base64Cipher and hexKey are required for decryption");
  }

  const cipherBuffer = Buffer.from(base64Cipher, "base64");
  const keyBuffer = Buffer.from(hexKey, "hex");

  const iv = cipherBuffer.slice(0, 16); // First 16 bytes = IV
  const encryptedData = cipherBuffer.slice(16); // Remaining = Ciphertext

  const decipher = crypto.createDecipheriv("aes-256-cbc", keyBuffer, iv);
  let decrypted = decipher.update(encryptedData);
  decrypted = Buffer.concat([decrypted, decipher.final()]);

  return decrypted.toString("utf-8");
};
